import gql from 'graphql-tag';

export class UserFragment {
    static applicationParameter = gql`
        fragment applicationParameter on ParametresUserAppliModelDTO {
            CodeActivite
            CodeChamp
            CodeValeur
            IdActivite
            IdChamp
            IdValeur
            IsParametreCE
            IsParametreUser
        }`;

    static ceDelegation = gql`
        fragment ceDelegation on CEDelegationDTO {
                Id
                CECodl
                CENom
                CEIdcGlob
                CEIdCclo
                CEEmail
    }`;
}
